/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {InvoiceTranslationListPageComponent} from './invoice-translation-list-page.component';

@Component({
  standalone: true,
  imports: [InvoiceTranslationListPageComponent],
  selector: 'adn-invoice-translation-route-page',
  template: `
    <adn-invoice-translation-list-page [readOnly]="readOnly"></adn-invoice-translation-list-page>
  `
})
export class InvoiceTranslationRoutePageComponent {
  @Input() readOnly = false;
}
